import { ProductsStatistics } from './models/products-statistics';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DashboardService } from './services/dashboard.service';
import { SubSink } from 'subsink';
import { BreadcrumbService } from '../layout/service/app.breadcrumb.service';

@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrls: ['./main-dashboard.component.scss']
})
export class MainDashboardComponent implements OnInit, OnDestroy {
  private _subs = new SubSink();
  public productsStatistics: ProductsStatistics;

  constructor(
    private _dashboardService: DashboardService,
    private _breadcrumbService: BreadcrumbService
  ) { }

  ngOnInit(): void {
    this._breadcrumbService.setItems([{label: 'Dashboard'}]);
    this._subs.add(
      this._dashboardService.fetchProductsStatistics().subscribe(response => {
        if (response.success) {
          this.productsStatistics = response.returnObject;
        }
      })
    );
  }

  ngOnDestroy(): void {
      if (this._subs) this._subs.unsubscribe();
  }

}
